export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyAtExp9Sql3qqnIstTwBvq67dS_8VAfCzU',
    authDomain: 'prologix-test.firebaseapp.com',
    databaseURL: 'https://prologix-test-default-rtdb.asia-southeast1.firebasedatabase.app',
    projectId: 'prologix-test',
    storageBucket: 'prologix-test.appspot.com',
    messagingSenderId: '862331447268',
    appId: '1:862331447268:web:36c8d51a66d2604281c9f1',
    measurementId: 'G-E42SB2VW33'
  },
  googleMapsApiKey: 'AIzaSyDGZ8TrVDHqCjEOtfjUws-iaLJ1WbndUDM',
  restApiUrl: 'https://rest-api-862331447268.asia-south1.run.app/api/',
  whatsAppOtpEnabled: true
};
